import React from 'react';
import PropTypes from 'prop-types';
import { ToggleSmall, TooltipDefinition } from 'carbon-components-react';

const showRecent = (flag: boolean) => {
  const { loadedMap } = window;
  if (loadedMap) {
    const layer = loadedMap.findLayerById('recent-enquiries-layer');
    if (layer) {
      layer.visible = flag;
    }
  }
};

const getRecent = () => {
  const { loadedMap } = window;
  if (loadedMap) {
    const layer = loadedMap.findLayerById('recent-enquiries-layer');
    if (layer) {
      return layer.visible;
    }
  }

  return false;
};

const ShowRecentsToggle: React.FC<Props> = ({ noTooltip }) => {
  return (
    <div className="show-recents-container">
      <ToggleSmall
        aria-label="Show recents"
        defaultToggled={getRecent()}
        id="map-tools-show-recent-toggle"
        labelA={noTooltip ? 'Show recents' : ''}
        labelB={noTooltip ? 'Show recents' : ''}
        onToggle={(flag: boolean) => showRecent(flag)}
      />
      {!noTooltip && (
        <div className="tooltip-container">
          <TooltipDefinition
            tooltipText={
              <div className="tooltip-text-content">
                Include the outlines of your last 7 days of enquiries on the map
                to help you draw and position new ones
              </div>
            }
            direction={'top'}
            align={'end'}
            className="show-recents-tooltip"
          >
            Show recents
          </TooltipDefinition>
        </div>
      )}
    </div>
  );
};

const propTypes = {
  noTooltip: PropTypes.bool
};
type Props = PropTypes.InferProps<typeof propTypes>;
ShowRecentsToggle.propTypes = propTypes;
ShowRecentsToggle.displayName = 'ShowRecentsToggle';
export default React.memo(ShowRecentsToggle);
